export const STRESS_TEST_MISSING_TITLE_ERROR = 'Stress Test Title is required';
export const STRESS_TEST_DATE_RANGE_ERROR = 'A valid date range is required';
